import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import cn from '@ui/utils/cn'
import Typography from '@ui/typography'
import Icon from '@ui/elements/Icon'
import {
  sBackColor,
  sPriceInfo,
  sTextColor,
  sizeTypography,
  sizeTypographyIncluded,
} from './styles'
import { Props } from './types'
import { useCurrencyDecimals, useCurrencySign } from 'hooks/useCurrency'
import { NumberUtils } from '@ca/common'
import { leadingNone } from '@ui/typography/styles'

const formatPrice = (value: number, decimals: number) => {
  return NumberUtils.round.decimal(value, decimals)
}

export default function PriceInfo({
  value,
  size = 'small',
  suffix,
  className,
}: Props) {
  const { t } = useTranslation('common')
  const currencySign = useCurrencySign()
  const decimals = useCurrencyDecimals()
  const included = !value // handle null?
  const discount = Boolean(!included && value && value < 0)
  const color = sTextColor(discount, included)

  const suffixText = suffix
    ? t(`steps:priceSuffix.${suffix}.short`, suffix)
    : null

  return (
    <View
      className={cn(
        sPriceInfo({ size, included }),
        sBackColor(discount, included),
        className
      )}
    >
      {!included && value && (
        <>
          <Icon
            name={discount ? 'minus' : 'plus'}
            size={12}
            strokeWidth={4}
            color={color}
          />
          <Typography
            variant={sizeTypography[size]}
            color={color}
            className={cn(leadingNone)}
          >
            {formatPrice(discount ? value * -1 : value, decimals)}
            {size === 'default' && !suffixText ? ' ' : ''}
            {currencySign}
          </Typography>
          {suffixText && (
            <Typography
              variant="XSB"
              color={color}
              className={cn(leadingNone, 'opacity-50')}
            >
              {suffixText}
            </Typography>
          )}
        </>
      )}
      {included && (
        <Typography
          variant={sizeTypographyIncluded[size]}
          className={cn(leadingNone, 'uppercase')}
          color={color}
        >
          {t('common:included')}
        </Typography>
      )}
    </View>
  )
}
